jQuery(function($){
	$(document).ready(function(e){

		$('.openClickFrenzyModal').trigger('click');
		$('.openClickFrenzySModal').trigger('click');
		let verifyAgeCookie = getLocationCookie('verify-age');
		if( !verifyAgeCookie ) {
			$('.openVerifyAgeModal').trigger('click');
		}
		$('#verifyAgeModal').on('shown.bs.modal', function () {
			$('body').addClass('age-modal-open')
		})
		$('#verifyAgeModal').on('hidden.bs.modal', function () {
			$('body').removeClass('age-modal-open')
		})

		

        //$('.openSWModal').trigger('click');
		if( verifyAgeCookie ) {
			triggerLocationPopup();
			triggerLocationQFFPopup();
		}

		if( $(".openLocationModal").hasClass('ageverify-disabled') ) {
			triggerLocationPopup();
		}

		if( $(".openLocationQFFModal").hasClass('ageverify-disabled') ) {
			triggerLocationQFFPopup();
		}

		function triggerLocationPopup() {
			let checkLocationCookie = getLocationCookie('locationSelected');
			//console.log(checkLocationCookie);
			if( !checkLocationCookie ) {
				$('.openLocationModal').trigger('click');
			}
		}

		function triggerLocationQFFPopup() {
			$('.openLocationQFFModal').trigger('click');
		}
			
		$(".location-select").on("click", function(e) {
			//sessionStorage.setItem("location-selected", "yes");
			document.cookie = "locationSelected=yes;path=/";
		});

        $(".location-modal-container .dropdown-menu .location-select-d").on("click", function(e) {
            var selectedLocationIdAttr = $(this).attr('id');
            var selectedLocationURL = $(this).attr('data-location-url');
            var selectedLocationID = $(this).attr('data-location-id');
            $('.location-modal-submit-banner a').attr('href', selectedLocationURL);
            if( selectedLocationID == 1 ) {
              $('.location-modal-submit-banner a').addClass('current-location');
              $('.location-modal-submit-banner a').attr('href', '#');
            } else {
              $('.location-modal-submit-banner a').removeClass('current-location');
            }
            $('.location-modal-container .dropdown-menu .location-select-d').show();
            $('.location-modal-container .location-modal-l-banner').removeClass('showing');
            $('.location-modal-container .location-modal-l-banner').addClass('not-showing');
            //$('.location-modal-container .location-modal-l-banner').css({'visibility': 'hidden', 'opacity': 0});
            $('.location-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).addClass('showing');
            $('.location-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).removeClass('not-showing');
            //$('.location-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).css({'visibility': 'visible', 'opacity': 1});
            $('.location-modal-container .dropdown-menu .'+selectedLocationIdAttr).hide();
			var selectedText = $(this).find('.modal_locationbar_location-text').html();
            $(".location-modal-container .dropdown-toggle .modal_locationbar_location-text").html(selectedText);
		});

		$(".location-qff-modal-container .dropdown-menu .location-select-d").on("click", function(e) {
            var selectedLocationIdAttr = $(this).attr('id');
            var selectedLocationURL = $(this).attr('data-location-url');
            var selectedLocationID = $(this).attr('data-location-id');
            $('.location-qff-modal-submit-banner a').attr('href', selectedLocationURL);
            if( selectedLocationID == 1 ) {
              $('.location-qff-modal-submit-banner a').addClass('current-location');
              $('.location-qff-modal-submit-banner a').attr('href', selectedLocationURL);
            } else {
              $('.location-qff-modal-submit-banner a').removeClass('current-location');
            }
            $('.location-qff-modal-container .dropdown-menu .location-select-d').show();
            $('.location-qff-modal-container .location-modal-l-banner').removeClass('showing');
            $('.location-qff-modal-container .location-modal-l-banner').addClass('not-showing');
            //$('.location-qff-modal-container .location-modal-l-banner').css({'visibility': 'hidden', 'opacity': 0});
            $('.location-qff-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).addClass('showing');
            $('.location-qff-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).removeClass('not-showing');
            //$('.location-qff-modal-container .location-modal-l-banner.'+selectedLocationIdAttr).css({'visibility': 'visible', 'opacity': 1});
            $('.location-qff-modal-container .dropdown-menu .'+selectedLocationIdAttr).hide();
			var selectedText = $(this).find('.modal_locationbar_location-text').html();
            $(".location-qff-modal-container .dropdown-toggle .modal_locationbar_location-text").html(selectedText);
		});
		
		/*$(".location-select-d").on("click", function(e) {
			//sessionStorage.setItem("location-selected", "yes");
			document.cookie = "locationSelected=yes;path=/";
			$('.close-location-modal').trigger('click');
		});*/

        $(".location-modal-submit-banner a").on("click", function(e) {
          if( $(this).hasClass('current-location') ) {
            e.preventDefault();
          }
          document.cookie = "locationSelected=yes;path=/";
          $('.close-location-modal').trigger('click');
        });

		$(".location-qff-modal-submit-banner a").on("click", function(e) {
		  if( $(this).hasClass('current-location') ) {
            //e.preventDefault();
			document.cookie = "locationQffSelected=yes;path=/";
          }
          document.cookie = "locationSelected=yes;path=/";
          $('.close-location-modal').trigger('click');
        });

        $(".sw-select-d").on("click", function(e) {
			//sessionStorage.setItem("location-selected", "yes");
			document.cookie = "SWSelected=yes;path=/";
			$('.close-sw-modal').trigger('click');
		});
		
		$(document).on('click', '#verify-agecheck', function(e){
			$('#verify-agecheck').removeClass('check-error');
		})	
		$(document).on('click', '.verify-age-confirm-button', function(e){
    		e.preventDefault();
			$('#verify-agecheck').removeClass('check-error');
			if ($('#verify-agecheck').is(':checked')) {
				var date = new Date();
    			date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
				var expires = "; expires=" + date.toUTCString();
				document.cookie = "verify-age=yes;path=/;domain=lottedutyfree.com.au;"+ expires;
    			$('.close-verify_age-modal').trigger('click');
				setTimeout(function(){
					triggerLocationPopup();
					triggerLocationQFFPopup();
				}, 100);
			} else {
				$('#verify-agecheck').addClass('check-error');
			}
            
    	})
		$(document).on('click', '.close-trigger-verify_age-modal', function(e){
    		e.preventDefault();
    		$('.close-verify_age-modal').trigger('click');
    	})

		$(document).on('click', '.close-trigger-location-qff-modal', function(e){
    		e.preventDefault();
            //document.cookie = "locationSelected=yes;path=/";
    		$('.close-location-modal').trigger('click');
    	})

		$(document).on('click', '.close-trigger-location-modal', function(e){
    		e.preventDefault();
            document.cookie = "locationSelected=yes;path=/";
    		$('.close-location-modal').trigger('click');
    	})
		
		$(document).on('click', '.close-trigger-location-frenzy-modal', function(e){
    		e.preventDefault();
            //document.cookie = "locationSelected=yes;path=/";
    		$('.close-location-modal').trigger('click');
    	})

        $(document).on('click', '.avatar_chat_trigger', function(e){
              $('.avatar-block').removeClass('bot_closed');
              $('.avatar-block').addClass('bot_open');
              $('.avatar_chat_trigger').hide();
        })
        $(document).on('click', '.avatar_chat_close_trigger_icon', function(e){
              $('.avatar-block').removeClass('bot_open');
              $('.avatar-block').addClass('bot_closed ');
              $('.avatar_chat_trigger').show('300');
        })

        let checkSWCookie = getLocationCookie('SWSelected');
		//console.log(checkLocationCookie);
		if( !checkSWCookie ) {
			$('.openSWModal').trigger('click');
            if( $('.openSWModal').length > 0 ) {
              $("body").addClass('sw-modal-open');
              $("html").addClass('sw-modal-open');
            }
		} 

        $('#swModal').on('hide.bs.modal', function (e) {
			$("body").removeClass('sw-modal-open');
            $("html").removeClass('sw-modal-open');
		})
		$('#swModal').on('shown.bs.modal', function (e) {
			$("body").addClass('sw-modal-open');
            $("html").addClass('sw-modal-open');
		})
		
      function getLocationCookie(cname) {
    	var name = cname + '=';
    	var decodedCookie = decodeURIComponent(document.cookie);
        //console.log(decodedCookie);
    	var ca = decodedCookie.split(';');
    	for (var i = 0; i < ca.length; i++) {
    		var c = ca[i];
    		while (c.charAt(0) === ' ') {
    			c = c.substring(1);
    		}
    		if (c.indexOf(name) === 0) {
    			return c.substring(name.length, c.length);
    		}
    	}
    	return '';
      }
      
		var windowsWidth = $(window).width();
		
		var checkZendeskLoaded = setInterval(function () {
			if ( typeof zE === 'undefined' ) {
			
			} else {
				$('.chat_frame-modal-block').show();
				clearInterval(checkZendeskLoaded);
			}
		}, 100);

		
		
		/*document.addEventListener('ON_CART_UPDATED', function(e) {
			var cartToken = e.detail.cart.token;
			$.ajax({
				url: "https://order.lotte-dutyfree.com.au/save-cart-token.php",
				type: 'POST',
				data: '&carttoken='+cartToken,
				success: function (data) {
					console.log('success');
				}
			})
		});*/
		
		$(".link-parent-arrow").on("click", function(e) {
			e.preventDefault();
			var toClose = $(this).parent().next();
			toClose.slideUp();
			toClose.parent().removeClass("open");
			if(!$(this).parent().next().is(":visible")) {
				var toOpen = $(this).parent().next();
				toOpen.slideDown();
				toOpen.parent().not(".open").addClass("open");
			}  
			e.stopPropagation();
		});
			
		$(".brand-menu-open").on("click", function(e) {
			e.preventDefault();
			$('.sf-custom-brand-menu .sf-block-aside').css({'display': 'block'});
			$('body').addClass('sidebar-open');
		});
			
		$(".sf_brand_sidebar-close").on("click", function(e) {
			e.preventDefault();
			$('.sf-custom-brand-menu .sf-block-aside').css({'display': 'none'});
			$('body').removeClass('sidebar-open');
		});
			
		$(".brandmenu-sidebar .sf-aside-content-overlay").on("click", function(e) {
			e.preventDefault();
			$('.sf-custom-brand-menu .sf-block-aside').css({'display': 'none'});
			$('body').removeClass('sidebar-open');
		});
		
		$(document).on('click', 'a.chat-modal-launcher', function(e){
			e.preventDefault();
			zE('messenger', 'open');
		})

      let extQantasDataURL = 'https://order.lotte-dutyfree.com.au/qantas/check-user-qantas.php';
      let checkSessionQFFData = new FormData();

      fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
          if (data.attributes) {
            const memberId = data.attributes.qff_member_id;
            const lastName = data.attributes.qff_member_last_name;
            const memberStatus = data.attributes.qff_member_status;
            const updatedAt = Date.now();
            let checkCartPageLoaded;
            if( typeof memberId != 'undefined' ) {
              if( memberId !== null ) {
                if( memberId != "" ) {
                  if( memberId != "0" || memberId != 0 ) {
                    //console.log('memberId--'+memberId);
                    //console.log('memberId No attributes found in cart.');
                    $('#qff_member_id').val(memberId);
                    $('#qff_member_last_name').val(lastName);
                    localStorage.setItem("qff_number", memberId);
                    localStorage.setItem("qff_name", lastName);
                    localStorage.setItem("qff_status", memberStatus);
                    $('.removeMembershipModal').show();
                    $('.addMembershipModal').hide();
                    checkCartPageLoaded = setInterval(function(){
                      if( $('#shopify-section-cart-drawer').length > 0 ) {
                          //console.log('memberId-1-'+memberId);
            				clearInterval(checkCartPageLoaded);
            				//console.log('userQffNum--'+userQffNum);
                          $('.removeMembershipModal').show();
                          $('.addMembershipModal').hide();
                		}
                    }, 100);
                  } else {
                    clearMembership();
                    //console.log('memberId-2-'+memberId);
                    //console.log('No attributes found in cart.');
                    localStorage.removeItem("qff_name"); 
                    localStorage.removeItem("qff_number");
                    localStorage.removeItem("qff_status"); 
                    $('.removeMembershipModal').hide();
                    $('.addMembershipModal').show();
                    checkCartPageLoaded = setInterval(function(){
                        if( $('#shopify-section-cart-drawer').length > 0 ) {
              				clearInterval(checkCartPageLoaded);
              				//console.log('userQffNum---'+userQffNum);
                            $('.removeMembershipModal').hide();
                            $('.addMembershipModal').show();
                      	}
                    }, 100);
                  }
                } else {
                  clearMembership();
                  //console.log('memberId-2-'+memberId);
                  //console.log('No attributes found in cart.');
                  localStorage.removeItem("qff_name"); 
                  localStorage.removeItem("qff_number");
                  localStorage.removeItem("qff_status"); 
                  $('.removeMembershipModal').hide();
                  $('.addMembershipModal').show();
                  checkCartPageLoaded = setInterval(function(){
                      if( $('#shopify-section-cart-drawer').length > 0 ) {
            				clearInterval(checkCartPageLoaded);
            				//console.log('userQffNum---'+userQffNum);
                          $('.removeMembershipModal').hide();
                          $('.addMembershipModal').show();
                    	}
                  }, 100);
                }
              } else {
                clearMembership();
                //console.log('memberId-3-'+memberId);
                //console.log('No attributes found in cart.');
                localStorage.removeItem("qff_name"); 
                localStorage.removeItem("qff_number");
                localStorage.removeItem("qff_status"); 
                $('.removeMembershipModal').hide();
                $('.addMembershipModal').show();
                checkCartPageLoaded = setInterval(function(){
                      if( $('#shopify-section-cart-drawer').length > 0 ) {
            				clearInterval(checkCartPageLoaded);
            				//console.log('userQffNum----'+userQffNum);
                          $('.removeMembershipModal').hide();
                          $('.addMembershipModal').show();
                		}
                }, 100);
              }
            } else {
                clearMembership();
                //console.log('memberId-4-'+memberId);
                //console.log('No attributes found in cart.');
                localStorage.removeItem("qff_name"); 
                localStorage.removeItem("qff_number");
                localStorage.removeItem("qff_status"); 
                $('.removeMembershipModal').hide();
                $('.addMembershipModal').show();
                checkCartPageLoaded = setInterval(function(){
                      if( $('#shopify-section-cart-drawer').length > 0 ) {
            				clearInterval(checkCartPageLoaded);
            				//console.log('userQffNum-----'+userQffNum);
                          $('.removeMembershipModal').hide();
                          $('.addMembershipModal').show();
                		}
                }, 100);
            }
          } else {
            clearMembership();
            //console.log('memberId-5-'+memberId);
            //console.log('No attributes found in cart.');
            localStorage.removeItem("qff_name"); 
            localStorage.removeItem("qff_number");
            localStorage.removeItem("qff_status"); 
            $('.removeMembershipModal').hide();
            $('.addMembershipModal').show();
            checkCartPageLoaded = setInterval(function(){
                    if( $('#shopify-section-cart-drawer').length > 0 ) {
          				clearInterval(checkCartPageLoaded);
          				//console.log('userQffNum------'+userQffNum);
                        $('.removeMembershipModal').hide();
                        $('.addMembershipModal').show();
              		}
            }, 100);
          }
          $('.qantas_membership_number').val('');
          $('.qantas_last_name').val('');
      })

      function clearMembership(){
        let userQffName = localStorage.getItem("qff_name");
        let userQffNum = localStorage.getItem("qff_number");
        let userQffStatus = localStorage.getItem("qff_status");
         //console.log('userQffName-e33-'+userQffName);
        
        if( userQffNum !== null ) {
          if( userQffNum != '' ) {
           if( userQffNum !=  '0' || userQffNum != 0 ) {
              //console.log('userQffName--'+userQffName);
              const checkCartLastLoaded = setInterval(function(){
                if( $('#shopify-section-cart-drawer').length > 0 ) {
      				clearInterval(checkCartLastLoaded);
      				//console.log('userQffNum----uuuuu---'+userQffNum);
                    $('.removeMembershipModal').show();
                    $('.addMembershipModal').hide();
                      
                    /*$('.qantas-popup-addcontainer').hide();
                    $('.qantas-popup-container-filled').hide();
                    $('.qantas-popup-bannercontainer').hide();
                    $('.qantas-popup-added-bannercontainer').show();
                    $('.qantas_membership_vnumber').text(userQffNum);
                    $('.qantas_last_vname').text(userQffName);*/
          		}
              }, 100);
    
              $('.removeMembershipModal').show();
              $('.addMembershipModal').hide();
    
              $('.qantas_membership_number').val('');
              $('.qantas_last_name').val('');
            } else {
              localStorage.removeItem("qff_name"); 
              localStorage.removeItem("qff_number");
               localStorage.removeItem("qff_status");
              $('.removeMembershipModal').hide();
              $('.addMembershipModal').show();
              checkCartPageLoaded = setInterval(function(){
                if( $('#shopify-section-cart-drawer').length > 0 ) {
              	clearInterval(checkCartPageLoaded);
            		//console.log('userQffNum----77--'+userQffNum);
                  $('.removeMembershipModal').hide();
                  $('.addMembershipModal').show();
                }
              }, 100);
            }
          } else {
            //console.log('No attributes found in cart.');
            localStorage.removeItem("qff_name"); 
            localStorage.removeItem("qff_number");
            localStorage.removeItem("qff_status"); 
            $('.removeMembershipModal').hide();
            $('.addMembershipModal').show();
            checkCartPageLoaded = setInterval(function(){
              if( $('#shopify-section-cart-drawer').length > 0 ) {
            	clearInterval(checkCartPageLoaded);
          		//console.log('userQffNum----77--'+userQffNum);
                $('.removeMembershipModal').hide();
                $('.addMembershipModal').show();
              }
            }, 100);
          }
        } else {
            //console.log('No attributes found in cart.');
            localStorage.removeItem("qff_name"); 
            localStorage.removeItem("qff_number");
            localStorage.removeItem("qff_status"); 
            $('.removeMembershipModal').hide();
            $('.addMembershipModal').show();
            checkCartPageLoaded = setInterval(function(){
              if( $('#shopify-section-cart-drawer').length > 0 ) {
            	clearInterval(checkCartPageLoaded);
          		//console.log('userQffNum----776--'+userQffNum);
                $('.removeMembershipModal').hide();
                $('.addMembershipModal').show();
              }
            }, 100);
        }
      }

      let getUserQffCookie = getCookie('userQffCookie');
      let userQffNum = localStorage.getItem("qff_number");
      let userQffName = localStorage.getItem("qff_name");
      let userQffStatus = localStorage.getItem("qff_status");
       
      //console.log('userQffName--'+userQffName);
      
      if( userQffNum !== null ) {
        if( userQffNum != '' ) {
          if( userQffNum !=  '0' || userQffNum != 0 ) {
            //console.log('userQffName--'+userQffName);
            const checkCartLoaded = setInterval(function(){
              if( $('#shopify-section-cart-drawer').length > 0 ) {
    				clearInterval(checkCartLoaded);
    				//console.log('userQffNum-------'+userQffNum);
                  $('.removeMembershipModal').show();
                  $('.addMembershipModal').hide();
                  setTimeout(function(){
                    clearMembership();
                  }, 1000);
                  /*$('.qantas-popup-addcontainer').hide();
                  $('.qantas-popup-container-filled').hide();
                  $('.qantas-popup-bannercontainer').hide();
                  $('.qantas-popup-added-bannercontainer').show();
                  $('.qantas_membership_vnumber').text(userQffNum);
                  $('.qantas_last_vname').text(userQffName);*/
        		}
            }, 100);
  
            $('.removeMembershipModal').show();
            $('.addMembershipModal').hide();
  
            $('.qantas_membership_number').val('');
            $('.qantas_last_name').val('');
            setTimeout(function(){
              clearMembership();
            }, 1000);
          }
        }
      }
      
      if( getUserQffCookie != '' ) {
      	//alert('test1');
      	//checkUserCart(getUserQffCookie);
      } else {
      	//alert('test2');
      	/*********** If userCookie empty ***********/
      	generateUniqueString();
      }

      function getCookie(cname) {
        	var name = cname + '=';
        	var decodedCookie = decodeURIComponent(document.cookie);
        	var ca = decodedCookie.split(';');
        	for (var i = 0; i < ca.length; i++) {
        		var c = ca[i];
        		while (c.charAt(0) === ' ') {
        			c = c.substring(1);
        		}
        		if (c.indexOf(name) === 0) {
        			return c.substring(name.length, c.length);
        		}
        	}
        	return '';
        }

        function setCookie(cname, cvalue) {
        	document.cookie = cname + '=' + cvalue + ';path=/';
        }
        
        function setCookieExpiry(cname, cvalue, exdays) {
        	var d = new Date();
        	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        	var expires = 'expires=' + d.toUTCString();
        	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        }
        
        function generateUniqueString() {
        	const d = new Date();
        	let nowTime = d.getTime();
        	let assignString = genRandomString(5) +'-'+ nowTime;
        	checkSessionQFFData.append("session_cookie", assignString);
        	checkSessionQFFData.append("type", "check-is-unique");
        	fetch(extQantasDataURL, { 
        		method: 'POST',
        		headers: {
        			'Accept': 'application/json',
        		},
        		body: checkSessionQFFData
        	}).then(response => response.json())
        	.then(function (response) {
        		if( response.unique == 'yes' ) {
        			//alert('test3');
                  setCookie('userQffCookie', assignString);
                  sessionStorage.setItem("userQffCookie", assignString);
        			//checkUserCart(assignString)
        		} else {
        			//alert('test4');
        			generateUniqueString();
        		}
        	});
        }
        
        function genRandomString(length) {
           let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
           let charLength = chars.length;
           let result = '';
           for ( let i = 0; i < length; i++ ) {
              result += chars.charAt(Math.floor(Math.random() * charLength));
           }
           return result;
        }

        $(document).on('click', '#qantas_add_membership', function(e){
            $('.qantas-processing-field').html('<span class="qantas-processing-text">Please wait. Verifying membership...</span>');
            var member_id = $('#qantas_membership_number').val();
            var lastname = $('#qantas_last_name').val();
            var countDownQff = $('.qantas-popup-addcontainer').attr("data-countdown-timer");
            if( member_id == '' || lastname == ''  ) {
              $('.qantas_not_found_error').hide();
              $('.qantas_empty_error').show();
              $('.qantas-processing-field').html("");
              return false;
            }
            let userQffCookie = getCookie('userQffCookie');
			$.ajax({
				url: "https://order.lotte-dutyfree.com.au/qantas/get-qantas-data.php",
				type: 'POST',
				data: '&member_id='+member_id+'&lastname='+lastname+'&user_cookie='+userQffCookie,
				success: function (response) {
                  var qantasData = $.parseJSON(response);
                  //alert(response.status);
                  if( qantasData.error_status == 'success' ) {
                    if( qantasData.status == 'ACTIVE' ) {
                      $('.qantas-popup-bannercontainer').hide();
                      $('.qantas-popup-added-bannercontainer').show();
                      $('.qantas_membership_vnumber').text(qantasData.member_id);
                      $('.qantas_last_vname').text(qantasData.lastname);
                      $('#qff_member_last_name').val(qantasData.lastname);
                      $('.qantas-popup-container').hide();
                      $('.qantas-popup-container-filled').show();
                      $('.addMembershipModal').hide();
                      $('.removeMembershipModal').show();
                      $('#qantas_remove_member_id').val(qantasData.member_id);
                      $('#qff_member_id').val(qantasData.member_id);
                      $('.qantas_empty_error').hide();
                      $('.qantas_not_found_error').hide();
                      localStorage.setItem("qff_number", qantasData.member_id);
                      localStorage.setItem("qff_name", qantasData.lastname);
                      localStorage.setItem("qff_status", 'active');
                      
                      localStorage.setItem("qff_data", JSON.stringify({ qff_number: qantasData.member_id, qff_name: qantasData.lastname }) );
                      fetch('/cart/update.js', {
                          method: "POST",
                          headers: {
                              'X-Requested-With': 'XMLHttpRequest',
                              'Content-Type': 'application/json;'
                          },
                          body: JSON.stringify({
                              attributes: {
                                qff_member_id: qantasData.member_id,
                                qff_member_last_name: qantasData.lastname,
                                qff_member_status: 'active'
                              }
                          })
                      })
                      $('.qantas_membership_number').val('');
                      $('.qantas_last_name').val('');
                    } else {
                      $('.qantas_empty_error').hide();
                      $('.qantas_not_found_error').show();
                      $('#qantas_Timer').show();
                      $('#qantas_add_membership').attr('disabled', 'disabled');
                      qFFCountdown(countDownQff);
                    }
                  }
                  if( qantasData.error_status == 'error' ) {
                    if( qantasData.status == 'limit_exceeded' ) {
                      $('.qantas_empty_error').hide();
                      $('.qantas_not_found_error').hide();
                      $('.qantas_limit_error').show();
                      $('#qantas_add_membership').prop('disabled', true);
                    } else {
                      $('.qantas_empty_error').hide();
                      $('.qantas_not_found_error').show();
                      $('#qantas_Timer').show();
                      $('#qantas_add_membership').prop('disabled', true);
                      qFFCountdown(countDownQff);
                    }
                    fetch('/cart/update.js', {
                          method: "POST",
                          headers: {
                              'X-Requested-With': 'XMLHttpRequest',
                              'Content-Type': 'application/json;'
                          },
                          body: JSON.stringify({
                              attributes: {
                                qff_member_id: '',
                                qff_member_last_name: '',
                                qff_member_status: ''
                              }
                          })
                    })
                  }
				  //console.log(qantasData.status);
                  $('.qantas-processing-field').html("");
				}
			})
        })

        function qFFCountdown(countDown) {
          var timeLeft = parseInt(countDown);
          var elem = document.getElementById('Timer');
          
          var timerId = setInterval(function(){
            if (timeLeft == 0) {
              clearTimeout(timerId);
              $('#qantas_Timer').hide();
              $('.qantas_Timer_time').text(countDown);
              $('#qantas_add_membership').prop('disabled', false);
            } else {
              $('.qantas_Timer_time').text(timeLeft);
              timeLeft--;
            }
          }, 1000);
        }

        $(document).on('click', '#qantas_remove_membership', function(e){
            $('.qantas-processing-removing-field').html('<span class="qantas-processing-text">Please wait. Removing membership...</span>');
            var member_id = $('#qantas_remove_member_id').val();
			$.ajax({
				url: "https://order.lotte-dutyfree.com.au/qantas/remove-qantas-data.php",
				type: 'POST',
				data: '&member_id='+member_id,
				success: function (response) {
                  $('.qantas-popup-added-bannercontainer').hide();
                  $('.qantas-popup-bannercontainer').show();
                  $('.qantas-popup-container').show();
                  $('.qantas-popup-container-filled').hide();
                  $('.addMembershipModal').show();
                  $('.removeMembershipModal').hide();
                  $('.close-rqantas-modal').trigger('click');
                  $('.qantas-processing-removing-field').html("");
                  localStorage.removeItem("qff_name"); 
                  localStorage.removeItem("qff_number"); 
                  $('.qantas_membership_number').val('');
                  $('.qantas_last_name').val('');
                  fetch('/cart/update.js', {
                          method: "POST",
                          headers: {
                              'X-Requested-With': 'XMLHttpRequest',
                              'Content-Type': 'application/json;'
                          },
                          body: JSON.stringify({
                              attributes: {
                                qff_member_id: '',
                                qff_member_last_name: '',
                                qff_member_status: ''
                              }
                          })
                    })
				}
			})
        })

      $(document).on('click', '.close-trigger-qantas-modal', function(e){
    		e.preventDefault();
            //document.cookie = "locationSelected=yes;path=/";
    		$('.close-qantas-modal').trigger('click');
    	})

      $(document).on('click', '.close-trigger-rqantas-modal', function(e){
    		e.preventDefault();
            //document.cookie = "locationSelected=yes;path=/";
    		$('.close-rqantas-modal').trigger('click');
    	})


      $(document).on('click', '#qantas_cancel_remove', function(e){
        $('.close-rqantas-modal').trigger('click');
      })
      
		const checkMenuLoaded = setInterval(function(){
			if( $('.gm-links .gm-item.gm-heading').length > 0 ) {
				clearInterval(checkMenuLoaded);
				$(".gm-links .gm-item.gm-heading").each(function(e) {
					if( $(this).next(".gm-item").hasClass('gm-heading') ) {
						$(this).addClass('has-no-subclass');
					}
				});
			}
			/*if( $('.gm-item').length > 0 ) {
				$(".gm-submenu .gm-item a").each(function(e) {
					$(this).removeAttr("title");
				});
				$(".gm-item a").each(function(e) {
					$(this).removeAttr("title");
				});
			}*/
			if( $('a[title]').length > 0 ) {
				$("a[title]").each(function(e) {
					var thisTitle = $(this).attr('title');
					$(this).attr('aria-label',thisTitle);
					$(this).removeAttr("title");
				});
			}
			if( $('.gm-text').length > 0 ) {
				$(".gm-text").each(function(e) {
					if( $(this).text() == 'Shop All' ) {
						$(this).parent().addClass("shop-all");
					}
					if( $(this).text() == 'Browse Collection' ) {
						$(this).parent().addClass("browse-collection");
					}
				});
			}
		}, 100);
		
		$(window).bind('scroll', function() {
			var scrollTop = $(window).scrollTop();
			var docHeight = $(document).height();
			var winHeight = $(window).height();
			var scrollPercent = (scrollTop) / (docHeight - winHeight);
			var scrollPercentRounded = Math.round(scrollPercent*100);
			//window.scrollPercent = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

			// Conditional code we'll use to fire events based on scrollPercentage.
			if (scrollPercentRounded >= 10) {
				$('#shopify-section-cart-data-sticky').addClass('in-view');
			} else {
				$('#shopify-section-cart-data-sticky').removeClass('in-view');
			}
		});
		$('#cartDataModal').on('hide.bs.modal', function (e) {
			$(".cart-form-save-error-wrapper").text('');
			$(".cart-form-save-error-wrapper").removeClass('error');
			$(".cart-form-save-error-wrapper").removeClass('success');
			$(".title-label").removeClass('error');
			$("html").removeClass('modal-open');
		})
		$('#cartDataModal').on('show.bs.modal', function (e) {
			$("html").addClass('modal-open');
		})
    });
	
	$(document).on('click', '.close-trigger-frenzy-modal', function(e){
		e.preventDefault();
		$('.close-frenzy-modal').trigger('click');
	})
    $(document).on('click', '.close-trigger-frenzys-modal', function(e){
		e.preventDefault();
		$('.close-frenzys-modal').trigger('click');
	})
	$('#cartErrorModal').on('hidden.bs.modal', function(){
		$(".sf-cart__submit-controls .cart__submit_button").removeClass('sf-spinner-loading');
	})

	$(document).on('click', '.slider-view-all-slides a', function(e){
		e.preventDefault();
		$('.view_all_slides').trigger('click');
	})
	$(document).on('click', '.slider-view-all-slides a', function(e){
		e.preventDefault();
		$('.view_all_slides').trigger('click');
	})
	$(document).on('click', '.close-search-container svg', function(e){
		e.preventDefault();
		$('.search-overscroll-contain').trigger('click');
	})
	$('#slider_viewAll_slides').on('show.bs.modal', function (e) {
		$('html').addClass('slides-modal-open');
	})
	$('#slider_viewAll_slides').on('hide.bs.modal', function (e) {
		$('html').removeClass('slides-modal-open');
	})
	$('#collapseFixedLocation').on('show.bs.collapse', function () {
		$('.sf-header').addClass('collapsed');
	})
	$('#collapseFixedLocation').on('hide.bs.collapse', function () {
		$('.sf-header').removeClass('collapsed');
	})
	$(document).ready(function(e){
		let options = {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric',
			timeZone: 'Australia/Brisbane'
		};
		var dateToday = new Date().toLocaleString('en', options);
		let currentTime = new Date(dateToday).getTime();
		//let minCalenderDate = setCollectionTime(currentTime);
		
		function setCollectionTime(selectedCollectionTime) {
			let hoursOpenAfter = 24;
			let options = {
				day: 'numeric',
				month: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				timeZone: 'Australia/Brisbane'
			};
			var dateToday = new Date().toLocaleString('en', options);
		
			let currentTime = new Date(dateToday).getTime();
			let hoursAllowed = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
			let updatedTIme = new Date(currentTime + hoursOpenAfter * 60 * 60 * 1000);
			let updatedDateHour = updatedTIme.getHours();
			let updatedDateHourTime = updatedTIme.getTime();
			let workDate;
			//let updatedDateHour = 15;
			let nextDayDate;
			//alert(selectedCollectionTime);
			//console.log(updatedDateHourTime+'-'+selectedCollectionTime);
			if( updatedDateHourTime > selectedCollectionTime) {
				//console.log("test 1");
				if( $.inArray(updatedDateHour, hoursAllowed) != -1 ) {
					//console.log("is in array");
					if( hoursAllowed[hoursAllowed.length - 1] == parseInt(updatedDateHour) ) {
						//console.log("test 5");
						workDate = new Date();
						workDate.setDate(updatedTIme.getDate()+1);
						nextDayDate = ( workDate.getMonth() + 1 ) + '/' + workDate.getDate() + '/' + workDate.getFullYear();
					} else {
						//console.log("test 6");
						for (let i = 0; i < hoursAllowed.length; i++) {
							if( hoursAllowed[i] <= updatedDateHour ) {
								$('#collection-hour option[value="'+hoursAllowed[i]+'"]').attr("disabled", true);
								$('#collection-hour').val('');
							}
						}
						nextDayDate = (updatedTIme.getMonth() + 1) + '/' +updatedTIme.getDate() + '/' + updatedTIme.getFullYear();
					}
				} else {
					//console.log("is NOT in array");
					//alert(hoursAllowed[hoursAllowed.length - 1]);
					if( hoursAllowed[hoursAllowed.length - 1] < updatedDateHour ) {
						//alert('test');
						//console.log("test 3");
						workDate = new Date();
						workDate.setDate(updatedTIme.getDate()+1);
						nextDayDate = ( workDate.getMonth() + 1 ) + '/' + workDate.getDate() + '/' + workDate.getFullYear();
					}
					if( hoursAllowed[0] > updatedDateHour ) {
						//alert('test1');
						//console.log("test 4");
						nextDayDate = ( updatedTIme.getMonth() + 1 ) + '/' + updatedTIme.getDate() + '/' + updatedTIme.getFullYear();
					}
				}
			} else {
				//console.log("test 2");
				for (let i = 0; i < hoursAllowed.length; i++) {
					$('#collection-hour option[value="'+hoursAllowed[i]+'"]').attr("disabled", false);
				}
				nextDayDate = (updatedTIme.getMonth() + 1) + '/' +updatedTIme.getDate() + '/' + updatedTIme.getFullYear();
			}
			return nextDayDate;
		}
		
		/*$('#collection-date').datepicker({ 
			dateFormat: 'yy-mm-dd',
			minDate: 1,
			maxDate: '+60d'
		});*/
		$('#flight-date').datepicker({ 
			dateFormat: 'yy-mm-dd', 
			minDate: 1, 
			maxDate: '+60d',
			onSelect: function(date,ins) {
				let currentLocDateTime = new Date();
				let currentLocHour = currentLocDateTime.getHours();
				let currentLocMin = currentLocDateTime.getMinutes();
				let selectedCalDate = Date.parse( ( ins.selectedMonth + 1 ) + '/' + ins.selectedDay + '/' + ins.selectedYear + ' ' + currentLocHour + ':' + currentLocMin + ':00');
				//console.log(( ins.selectedMonth + 1 ) + '/' + ins.selectedDay + '/' + ins.selectedYear + ' ' + currentLocHour + ':' + currentLocMin + ':00');
				//console.log(selectedCalDate);
				setCollectionTime(selectedCalDate);
			}
		});
		
		var slideElContainer = $('.home-banner__slideshow');
		var slideElArr;
		var slideElArrLink;
		if( slideElContainer.find('.swiper-slide:not(.swiper-slide-duplicate)').length > 0 ) {
			$(".slider_viewAll_slide_images").append('<ul class="view_all_list"></ul>');
			slideElContainer.find('.swiper-slide:not(.swiper-slide-duplicate)').each(function(){
				if( $(this).hasClass('slider_item') ) {
					slideElArr = $(this).find('.sf__slide-bg').find('img').attr('src');
					slideElArrLink = $(this).find('.sf-slider__link').attr('href');
					$(".slider_viewAll_slide_images ul").append('<li><a href="'+slideElArrLink+'"><img src="'+slideElArr+'"></a></li>');
				}
				/*if( $(this).hasClass('video_slide') ) {
					slideElArr = $(this).find('.sf__slide-bg').html();
					$(".slider_viewAll_slide_images ul").append('<li>'+slideElArr+'</li>');
				}*/
			})
		}
		
		
		var descMaxHeight = 200;
		var descHeight = $('.product-description-block').outerHeight();
		if( descMaxHeight < descHeight ) {
			$('.product-description-block').addClass('view-more');
			$('.product-description-content').addClass('view-more');
		}
		var windowsWidth = $(window).width();
		if( $('.video-container').length > 0 ) {
			$('.video-container').each(function(count){
				var $player = $(this);
				var $video = $player.find('#video');
				//video.controls = false;
				var $videoControls = $player.find('#video-controls');
				$videoControls.removeClass('hidden');
				var $volumeMute = $player.find('#mute-volume-button');
				var $volumeUnmute = $player.find('#unmute-volume-button');
				var $muteIcon = $player.find('use[href="#volume-mute"]');
				var $unmuteIcon = $player.find('use[href="#volume-high"]');
				var $playButton = $player.find('#play');
				var $pauseButton = $player.find('#pause');
				var $playIcon = $player.find('.play-icons use');
				var $pauseIcon = $player.find('.pause-icons use');
				var $volume = $player.find('#volume');
				var $autoplay = $player.attr('data-auto-play');
						
				$playButton.on('click', function(){
					$(this).closest('.video_slide').addClass('played');
					$video[0].muted = true;
					$video[0].volume = 0;
					$video[0].play();
					$volumeUnmute.removeClass( "hidden" );
					$volumeMute.addClass( "hidden" );
					$pauseIcon.removeClass( "hidden" );
					$playIcon.addClass( "hidden" );
					$playButton.addClass( "hidden" );
					$pauseButton.removeClass( "hidden" );
				})
				$pauseButton.on('click', function(){
					$video[0].pause();
					$pauseIcon.addClass( "hidden" );
					$playIcon.removeClass( "hidden" );
					$playButton.removeClass( "hidden" );
					$pauseButton.addClass( "hidden" );
				})
				$volumeMute.on('click', function(){
					$video[0].muted = true;
					$video[0].volume = 0;
					$volumeUnmute.removeClass( "hidden" );
					$volumeMute.addClass( "hidden" );
				})
				$volumeUnmute.on('click', function(){
					$video[0].muted = false;
					$video[0].volume = 1;
					$volumeUnmute.addClass( "hidden" );
					$volumeMute.removeClass( "hidden" );
				})
			});
		}
		if( windowsWidth > 767 ) {
			var startVideoSlide = setInterval(function () {
				if( $('.video_slide.swiper-slide-active').attr('data-auto-play') == "true" ) {
					var $playButton = $('.video_slide.swiper-slide-active').find('#play');
					$('.video_slide.swiper-slide-active').addClass('played');
					$playButton.trigger('click');
					clearInterval(startVideoSlide);
				}
			}, 100);
		}
		/*var startVideoSlideOnLoop = setInterval(function () {
			if( $('.video_slide.swiper-slide-active').hasClass('paused') ) {
				const playButton = $('.video_slide.swiper-slide-active').find('#play');
				$('.video_slide.swiper-slide-active').addClass('played');
				playButton.trigger('click');
				clearInterval(startVideoSlideOnLoop);
			}
		}, 100);*/
		var contentTop = $('#MainContent').offset().top;
		//console.log(contentTop);
		$(window).scroll(function () {
			if ( $(window).scrollTop() > contentTop ) {
				$('.sf-header').addClass('sticky-location');
			} else {
				$('.sf-header').removeClass('sticky-location');
			}
		})
		$(document).click(function(e) {
			if (!$(e.target).is('.panel-body')) {
				$('.collapse').collapse('hide');	    
			}
		});
		$(".tnc-link").click(function(e) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: $(".landing-page-terms-section").offset().top - 100
			}, 1000);
		});
		setTimeout(function(){
			$('.iframe-loading-img').fadeOut('slow');
		}, 3000);
		$(".pageIframes").each(function(){
			$('#'+$(this).attr('id')).on('load', function () {
                $('.iframe-loading-img').fadeOut('slow');
            });
			iFrameResize({ log: false, autoResize:true, inPageLinks: true }, '#'+$(this).attr('id'))
		})
		
		if( $('.fluid-scroll-slider-section').length > 0 ) {
			var fluidSplide = new Splide( '.fluid-scroll-slider-section .splide', {
				type   : 'loop',
				drag   : 'free',
				perPage: 3,
				breakpoints: {
					767: {
						perPage: 2,
						padding: '40px',
					},
				},
			});

			fluidSplide.mount();
		}
    })
	/*
	var checkBundlyProductsLoaded = setInterval(function () {
			if( $('.bundly__component_grid_item').length > 0 ) {
				$('.bundly__component_grid_item').each(function(index, element) {
					if ( $(this).children('.bundly__component_image').find('img').parent().is( "button" ) ) {
						$(this).children('.bundly__component_image').find('img').unwrap();
					}
				})
				//$('.bundly__component_image button').unwrap();
				clearInterval(checkBundlyProductsLoaded);
			}
		}, 100);
		*/
})